import React, { useEffect, useState } from 'react';
import { post } from '../../../api/baseUrl';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import type { WithingsCallbackResponse } from '../PatientDetails/types/withings';
import logo from '../../../assets/img/brandImage.png';

const WithingsCallback: React.FC = () => {
  const [isDenied, setIsDenied] = useState(false);
  const [hasError, setHasError] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('error') === 'access_denied') {
      setIsDenied(true);
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
      return;
    }
    const payload = {
      code: params.get('code') || null,
      state: params.get('state') || null,
    };

    const callBackend = async () => {
      if (!payload.code || !payload.state) {
        console.error('Withings callback missing code or state');
        return;
      }
      try {
        const {
          data: { message, data },
        } = await post<WithingsCallbackResponse>(
          'external-connections/withings/callback',
          {
            state: payload.state || '',
            code: payload.code || '',
          },
        );

        if (data && message.toLowerCase() === 'success') {
          window.location.href = `/patientDetails?access_token=${data.userAccessToken}`;
        } else {
          setHasError(true);
          setTimeout(() => {
            window.location.href = '/';
          }, 2000);
        }
      } catch (err) {
        console.error('Withings backend callback error:', err);
        setHasError(true);
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
      }
    };

    callBackend();
  }, []);

  return (
    <div
      style={{ height: '100vh' }}
      className="d-flex flex-column align-items-center justify-content-center gap-5"
    >
      <div className="flexHorizCentered clickable">
        <img id="brandImage" src={logo} alt="AI2 Logo" />
        <div id="caremappr">CAREMAPPR</div>
      </div>
      {hasError ? (
        <p>
          Something went wrong. Please try again. You will be redirected back to
          Caremappr.
        </p>
      ) : isDenied ? (
        <p>
          You've denied the access to Withings. You will be redirected back to
          Caremappr.
        </p>
      ) : (
        <LoadingSpinner showText="Processing Withings data, please wait ..." />
      )}
    </div>
  );
};

export default WithingsCallback;
